import React from 'react';
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthValidator = ({permission_level, children}) => {
    const uid = useSelector(store=>store.firebase.auth.uid);
    const profile = useSelector(store=>store.firebase.profile);
    if(uid){
        if(profile.isLoaded){
            if(profile.role>=permission_level){
                return children;
            }else{
                return <Redirect to="/"/>;;
            }
        }else{
            return <></>;
        }
    }else{
        return <Redirect to="/"/>;
    }
    
}
 
export default AuthValidator;